export default __webpack_public_path__ + "static/media/contact.c28e7785.svg";